import { EditIcon } from "assets";
import { DcddUserProfileProps, DcddUserProps } from "../../state/actionType";
import { CustomTooltip, MediumScreenModel } from "components";
import { useState } from "react";
import HandleUpdateDcddUser from "../HandleUpdateDcddUser";

interface Props {
  user: DcddUserProps;
  profile: DcddUserProfileProps;
  dcddData: DcddUserProps;
}

const DcddUserInfo: React.FC<Props> = ({ user, profile, dcddData}) => {
  const [openEdit, setOpenEdit] = useState(false);
  return (
    <div className=" max-w-4xl mx-auto">
      {/* Profile Picture */}
        <div className="my-6 flex flex-col w-32">
          <div className="w-32 h-32 rounded-full border bg-primary-400 shadow-md flex items-center justify-center text-primary-900 text-7xl font-bold">
            {profile?.name?.toUpperCase().charAt(0)}
          </div>
          <div className="flex items-center justify-center mt-2">
            <p className="text-xs text-gray-500 text-center">Edit User Detail</p>
            <CustomTooltip title="Edit user" placement="right">
              <button onClick={() => setOpenEdit(true)}>
                <EditIcon className="size-4 ml-1 text-primary-400 hover:text-primary-700" />
              </button>
            </CustomTooltip>
          </div>
        </div>
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">
        User Information
      </h1>
      {/* User Account Info */}
      <div className="bg-primary-50 shadow-md rounded-xl p-6 mb-6">
        <h2 className="text-lg font-semibold text-primary-600 mb-4">
          Account Details
        </h2>
        <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
          <InfoRow label="ID" value={dcddData?.id} />
          <InfoRow label="Login ID" value={dcddData?.login_id} />
          <InfoRow label="Email" value={dcddData?.email} />
          <InfoRow label="Mobile No." value={dcddData?.mobile_no} />
          <InfoRow label="Category" value={dcddData?.category} />
          <InfoRow label="Status" value={dcddData?.status} />
          <InfoRow label="Student ID" value={dcddData?.student_id} />
          <InfoRow label="User Identifier" value={dcddData?.user_identifier} />
        </div>
      </div>
      {/* Profile Info */}
      <div className="bg-primary-50 shadow-md rounded-xl p-6">
        <h2 className="text-lg font-semibold text-primary-600 mb-4">
          Profile Details
        </h2>
        <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
          <InfoRow label="Name" value={profile?.name} />
          <InfoRow label="Gender" value={profile?.gender} />
          <InfoRow label="Date of Birth" value={profile?.dob} />
          <InfoRow label="CID" value={profile?.cid} />
          <InfoRow label="Dzongkhag ID" value={profile?.dzongkhag_id} />
          <InfoRow label="Grade ID" value={profile?.grade_id} />
          <InfoRow label="ECCD ID" value={profile?.eccd_id} />
          <InfoRow label="Student ID" value={profile?.student_id} />
        </div>
      </div>
      {openEdit && (
        <MediumScreenModel showModal={openEdit} setShowModal={setOpenEdit}>
          <HandleUpdateDcddUser dcddUserData={dcddData} onClose={()=>setOpenEdit(false)} />
        </MediumScreenModel>
      )}
    </div>
  );
};

interface InfoRowProps {
  label: string;
  value: string;
}
const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-gray-500 font-medium">{label}</span>
    <span className="text-gray-800 break-all">{value || "—"}</span>
  </div>
);

export default DcddUserInfo;
